module.exports = __webpack_public_path__ + "img/trophy.70a5f132.svg";